module.exports = __webpack_public_path__ + "static-v-shop/1785501885960/img/cristal-ojo-derecho.97db1314.png";